const state = {
  tep: null,
  vectors: []
}
const getters = {}

const actions = {
  setTep({ commit }, tep) {
    commit('setTep', tep)
  },
  setVectors({ commit }, vectors) {
    commit('setVectors', vectors)
  }
}

const mutations = {
  setTep(state, tep) {
    state.tep = tep
  },
  setVectors(state, vectors) {
    state.vectors = vectors
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/diagnosi.js